import { Outlet, Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@clerk/clerk-react'
import { useDashboardPrefetch } from '../hooks/useDashboardPrefetch'

export function ProtectedLayout() {
  const loc = useLocation()
  const { isLoaded, userId } = useAuth()

  useDashboardPrefetch({ enabled: isLoaded && !!userId })

  if (!isLoaded) return null
  if (!userId)
    return (
      <Navigate
        to='/login'
        replace
        state={{ from: loc }}
      />
    )
  return <Outlet />
}
